import $ from 'domtastic';

const listViewMessage = {
  create(props, city) {
    const markup = '<p>Den här produktkategorin finns inte på den ort du har valt.</p>';
    if (!props) return this.fallbackMessage(markup, city);
    return this.fallbackMessage(markup, city);
  },

  fallbackMessage(markup, city) {
    const $markup = $(`
      ${markup}
      <p>För att se aktuellt produktutbud för denna kategori på våra andra orter, klicka nedan:</p>
      <p>
        <span style="display: block; height: 5px;" data-city="orebro"></span>
        <a href="#" class="js-list-view-link" data-city="orebro">Örebro</a>
        <span style="margin-right: 10px;" data-city="eskilstuna"></span>
        <a href="#" class="js-list-view-link" data-city="eskilstuna">Eskilstuna</a>
        <span style="margin-right: 10px;" data-city="vasteras"></span>
        <a href="#" class="js-list-view-link" data-city="vasteras">Västerås</a>
      </p>
      <p>
      <span style="display: block; height: 24px;" data-city="orebro"></span>
      Vill du ha hjälp? Hör av dig!
      </p>
      <p><a href="/kontakta-oss/">Här finns alla kontaktuppgifter du behöver</a></p>
    `);
    const $collection = $('<div></div>').append($markup);
    const $cityToRemove = $collection.find(`[data-city="${city}"]`);
    $cityToRemove.remove();
    const $newMarkup = $($collection);

    return $newMarkup;
  },
};

export default listViewMessage;



// WEBPACK FOOTER //
// ./components/markup/listViewMessage.js